module.exports = __webpack_public_path__ + "img/浙江大学logo-300x300.9402ad70.png";